var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.999 11.998C20.999 7.0293 16.9678 2.99805 11.999 2.99805C7.03027 2.99805 2.99902 7.0293 2.99902 11.998C2.99902 16.9668 7.03027 20.998 11.999 20.998C16.9678 20.998 20.999 16.9668 20.999 11.998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.14 15.6795L15.5049 12.4386C15.5796 12.393 15.6414 12.329 15.6843 12.2526C15.7272 12.1763 15.7497 12.0902 15.7497 12.0026C15.7497 11.9151 15.7272 11.829 15.6843 11.7526C15.6414 11.6763 15.5796 11.6122 15.5049 11.5667L10.14 8.32575C10.0631 8.27968 9.97534 8.25489 9.8857 8.25394C9.79607 8.25298 9.70779 8.27588 9.62993 8.3203C9.55206 8.36472 9.48742 8.42905 9.44262 8.5067C9.39782 8.58435 9.37449 8.67251 9.37501 8.76215V15.2431C9.37449 15.3327 9.39782 15.4209 9.44262 15.4985C9.48742 15.5762 9.55206 15.6405 9.62993 15.6849C9.70779 15.7294 9.79607 15.7523 9.8857 15.7513C9.97534 15.7503 10.0631 15.7256 10.14 15.6795Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonIcon);
export default __webpack_public_path__ + "static/media/PlayButtonIcon.3f3bde29.svg";
export { ForwardRef as ReactComponent };